import React, { useState, useEffect } from 'react'
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
  DropDown
} from '../../../components/commons';
import { connect } from 'react-redux';
import { PaperClipIcon } from '../../../components/Icon';
import { useLocation } from 'react-router-dom';
import {
  Label,
  Row,
  Col,
  Table, UncontrolledPopover, PopoverHeader, PopoverBody
} from 'reactstrap';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { RootState } from '../../../redux/rootReducers';
import {
  AddOpenItemCommentPayload,
  GetAllOpenItemCommentsPayload,
} from '../../../commonTypes/openItemsTypes';
import { CommentsModal } from '../../../components/OpenItems';
import {
  OpenItemsCommentType,
  SingleOpenItemDetailsType,
  SingleOpenItemDocumentType
} from '../../../redux/openItems/openItemsTypes';

import {
  resetOpenItemsError,
  getAdminOpenItemsSingleAction,
  updateStatusAdminOpenItemsAction,
  resetOpenItemsSuccess,
  addOpenItemCommentsAction,
  getAllOpenItemCommentsAction,
  resetOpenItemsCommentList
} from '../../../redux/openItems';
import { getAllJobsTrackerListAction, resetJobTrackerListing } from '../../../redux/listing';
import { ClientType } from '../../../redux/auth/authTypes';
import { resetSession } from '../../../redux/auth';
import { JobTrackerListingType } from '../../../redux/listing/listingTypes';
import { GetJobTrackerListingPayload } from '../../../commonTypes/listing';
import toast, { Toaster } from 'react-hot-toast';
import { formatDate } from '../../../utils/commonFunctions';
let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const ITEM_DATA: any[] = [{
  item_name: '',
  format: '',
  due_date: null,
  temp: null,
  temp1: null
}];

const STATUS = [
  {
    label: 'Approve',
    value: 3
  },
  {
    label: 'Reject',
    value: 2
  }
]
type dropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};

type AppProps = {
  history?: any;
  fetching: boolean;
  success: number | null;
  token: string | null;
  error: string | null;
  statusCode: number | null;
  commentsFetching: boolean;
  commentsSuccess: number | null;
  dispatchResetOpenItemsError: () => void;
  dispatchResetOpenItemsSuccess: () => void;
  clientList: ClientType[] | [];
  jobTrackerListing: [] | JobTrackerListingType[];
  // dispatchGetClientsActiveJobAction: (data: GetJobTrackerListingPayload) => void;
  dispatchResetJobTrackerListing: () => void;
  adminOpenItemSingle: any;
  dispatchResetSession: () => void;
  dispatchGetAdminOpenItemsSingle: (data: any) => void;
  dispatchUpdateStatusAdminOpenItemsAction: (data: any) => void;
  dispatchAddOpenItemCommentsAction: (data: AddOpenItemCommentPayload) => void;
  dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) => void;
  // dispatchResetOpenItemCommentsListAction: () => void;
  openItemsCommentsList: [] | OpenItemsCommentType[];
}

const AdminOpenItemSummary = ({
  history,
  fetching,
  clientList,
  success,
  statusCode,
  dispatchResetSession,
  token,
  error,
  jobTrackerListing,
  commentsFetching,
  commentsSuccess,
  dispatchResetOpenItemsError,
  dispatchResetOpenItemsSuccess,
  // dispatchGetClientsActiveJobAction,
  dispatchResetJobTrackerListing,
  adminOpenItemSingle,
  dispatchGetAdminOpenItemsSingle,
  dispatchUpdateStatusAdminOpenItemsAction,
  dispatchAddOpenItemCommentsAction,
  dispatchGetAllOpenItemCommentsAction,
  // dispatchResetOpenItemCommentsListAction,
  openItemsCommentsList
}: AppProps) => {

  const search = useLocation();
  const urlArr = search.pathname.split('/')
  const jobId = urlArr[urlArr.length - 1];

  const { currentTab } = history?.location?.state;

  // const [finalClientList, setFinalClientList] = useState<dropDownItemType[] | []>([]);

  const [showCommentModal, setShowCommentModal] = useState<boolean>(false);
  const [commentsModalData, setCommentsModalData] = useState<any>();
  const [allOpenItemComments, setAllOpenItemComments] = useState<[] | OpenItemsCommentType[]>([]);

  const [itemId, setItemId] = useState<number | null>(null);

  // const [documentStatus, setDocumentStatus] = useState<any[]>([])
  const [finalDocument, setFinalDocument] = useState<any[]>([])


  useEffect(() => {
    dispatchResetOpenItemsError();
    dispatchResetOpenItemsSuccess();
    dispatchResetJobTrackerListing();
    let data = {
      jobId,
      token
    }
    dispatchGetAdminOpenItemsSingle(data);
  }, []);

  useEffect(() => {
    if (openItemsCommentsList) {
      setAllOpenItemComments(openItemsCommentsList);
    }
  }, [openItemsCommentsList]);

  useEffect(() => {
    const {
      documents = [],
    } = adminOpenItemSingle;

    setFinalDocument(documents)

  }, [adminOpenItemSingle, openItemsCommentsList])

  const handleChange = (option: any, item_id: number, i: number) => {
    // debugger
    let newDoc = JSON.parse(JSON.stringify(finalDocument))
    // if(option === null) return false; 
    newDoc[i].approval_status_code = option?.value ? option?.value : {
      value: null,
      label: 'Select...'
    };

    setFinalDocument(newDoc);
  }


  const getStatus = (status: any) => {
    switch (true) {
      case (status == 1):
        return null;
      case (status === 2):
        return 'Rejected';
      case (status === 3):
        return 'Approved';
      default: return;
    }
  }

  const handleToggleCommentsModal = () => {
    setShowCommentModal(!showCommentModal);
    if (showCommentModal) {
      let finalData: GetAllOpenItemCommentsPayload = {
        item_id: itemId ? itemId : 0,
        token,
        open_item_id: +jobId
      }
      dispatchGetAllOpenItemCommentsAction(finalData);

      let data = {
        jobId,
        token
      }
      // dispatchGetAdminOpenItemsSingle(data);
    }
  }

  const {
    summary = '',
    job_id,
    job_type,
    documents = [],
    client_code,
    client_name
  } = adminOpenItemSingle

  const handleSubmit = () => {
    let item_data: any[] = [];
    finalDocument?.map((item: any) => {
      if (item?.approval_status_code && item?.approval_status_code !== 1) {
        item_data.push({
          "item_id": item?.item_id,
          "approval_status": item?.approval_status_code
        })
      }
      else return
    })

    let data = {
      jobId,
      token,
      item_data
    }
    dispatchUpdateStatusAdminOpenItemsAction(data)
    renderCommentsModal(data)

  }

  const renderCommentsModal = (data?: any) => {
    setItemId(data?.item_id)
    setCommentsModalData(data);
    if (token && data?.item_id) {
      let finalData: GetAllOpenItemCommentsPayload = {
        item_id: data?.item_id,
        token,
        open_item_id: +jobId
      }
      dispatchGetAllOpenItemCommentsAction(finalData)
    }
  }

  const handleAddOpenItemComment = (data: any) => {
    let finalData: AddOpenItemCommentPayload = {
      token,
      item_id: data?.id,
      open_item_id: +jobId,
      comment: data?.commentText
    }

    dispatchAddOpenItemCommentsAction(finalData);
  }

  const handleCommentsModalData = (data: any) => {
    handleToggleCommentsModal();
    renderCommentsModal(data);
  }

  const renderFilesList = (file: any, id: number) => {
    return file?.map((data: any, index: number) => {
      return <>
        <p className="mt-3" key={index}>
          <a href={data?.file_url ? `${ blobBaseUrl }${ data?.file_url }?${ blobToken }` : ''} target="_blank" className="uploaded_file_name">
            {data?.file_name}
          </a>
        </p>
      </>

    });
  }


  const renderUploadedFiles = (file: any, itemId: number) => {
    return (
      <UncontrolledPopover trigger="legacy" placement="bottom" target={`PopoverLegacy${ itemId }`}>
        <PopoverHeader>Total uploaded file list</PopoverHeader>
        <PopoverBody>

          {renderFilesList(file, itemId)}
        </PopoverBody>
      </UncontrolledPopover>
    )
  }

  const returnFileFormat = (format: string) => {
    switch (format) {
      case 'image':
        return 'Image';
      case 'word':
        return 'Word';
      case 'pdf':
        return 'PDF';
      case 'excel':
        return 'Excel';
      case 'hard_copy':
        return 'Hard Copy';
      default:
        return 'Image';
    }
  }


  const renderDocuments = () => {
    return finalDocument && finalDocument?.length && finalDocument?.map((item: any, i: number) => {

      const finalComment = item?.last_comment?.length > 15 ? `${ item?.last_comment?.slice(0, 15) }...` : item?.last_comment;

      return <tr>

        <td className='col-2'>{item.item_name}</td>
        <td className='col-2'><span className={`file-status-${ item?.format }`}>{returnFileFormat(item?.format)}</span></td>
        <td className='col-2'>{formatDate(item.due_date)}</td>
        <td className='col-2'>

          {
            item.upload.length ? <td className="position-relative pointer">
              <span id={`PopoverLegacy${ item?.item_id }`}>
                <PaperClipIcon />
                <span className="badge count-badge">
                  {item.upload.length}
                </span>
              </span>
              {renderUploadedFiles(item?.upload, item?.item_id)}
            </td> : <td> --/-- </td>
          }

        </td>

        <td className=''>{finalComment ?
          <>
            <span>{finalComment}</span><br />
            <span className="due-date-text">{moment.utc(item?.last_comment_date).local().format('DD-MM-YY, h:mm a')}</span>
          </> :
          '--/--'
        }</td>
        <td className='col-2'>
          <DropDown
            placeholder="Select"
            options={STATUS}
            // isClearable
            disabled={(adminOpenItemSingle?.documents[i]?.approval_status_code === 3 ? true :false) || (item?.upload?.length ? false : true)}
            handleChange={(option) => handleChange(option, item.item_id, i)}
            value={
              item['approval_status_code'] === 1 ? {
                value: null,
                label: 'Select...'
              } :
                {
                  label: getStatus(item['approval_status_code']),
                  value: item['approval_status_code']
                }
            }
          />

        </td>
        <td>
          <i
            className="fas fa-comments comment-icon"
            onClick={() => handleCommentsModalData(item)}
          ></i>
        </td>
      </tr>
    })
  }

  const handleCancel = () => {
    setFinalDocument([])
    history.push({
      pathname: `/open-items-admin`,
      state: { currentTab }
    })
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetOpenItemsError();
            }}
          />
        )
      }
    }

    if (commentsSuccess === 1) {
      dispatchResetOpenItemsSuccess();
      toast.success('Comment Added Successfully!', {
        duration: 2000
      });

      let finalData: GetAllOpenItemCommentsPayload = {
        item_id: itemId ? itemId : 0,
        token,
        open_item_id: +jobId
      }
      dispatchGetAllOpenItemCommentsAction(finalData);
    } else if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Items Submitted Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetOpenItemsSuccess();
            // setFinalFileData([]);
            history.push({
              pathname: `/open-items-admin`,
              state: { currentTab }
            });
          }}
        />
      )
    }
    return false;
  }

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Open item Summary" />
      </div>

      <div className="col-md-12 mt-4">
        <div className="content-area">
          <div className="row">
            <div className="col-12">
              <div
                className='mb-2'
                style={{
                  backgroundColor: 'lavender',
                  borderRadius: '4px',
                  padding: '8px'
                }}
              >
                <strong>{client_name} {client_code}</strong>
              </div>

            </div>
          </div>
          <div className='row'>
            <div className="col-6">
              <Label>Job Type</Label>
              <div>{job_type}</div>
              <div>{job_id}</div>
            </div>
            <div className="col-6">
              <Label>Summary</Label>
              <p>{summary}</p>
            </div>
          </div>
          <div className='table-bordered'>
            <Table className="table table-striped">
              <thead>
                <tr className="mt-3">
                  <th>Item name</th>
                  <th>Format</th>
                  <th>
                    Due Date
                  </th>
                  <th>
                    Upload File
                  </th>
                  <th>
                    Last Comment(Date)
                  </th>

                  <th>
                    Approve/Reject
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {renderDocuments()}
              </tbody>
            </Table>

          </div>

          <Row>
            <Col xs={12} className="text-right mt-3">
              <button className="btn btn-link" onClick={handleCancel}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
            </Col>
          </Row>

        </div>
      </div>
      {
        showCommentModal && <CommentsModal
          modal={showCommentModal}
          toggleModal={handleToggleCommentsModal}
          characterLength={150}
          data={commentsModalData}
          showInputBox={true}
          handlePostComment={handleAddOpenItemComment}
          commentFetching={commentsFetching}
          commentsSuccess={commentsSuccess}
          allOpenItemComments={allOpenItemComments}
        />
      }
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </div>
  )
};

const mapStateToProps = (state: RootState) => ({
  clientList: state.auth.clientList,
  token: state.auth.token,
  fetching: state.openItems.fetching,
  success: state.openItems.success,
  statusCode: state.openItems.statusCode,
  error: state.openItems.error,
  adminOpenItemSingle: state.openItems.adminOpenItemSingle,
  jobTrackerListing: state.listing.jobTrackerListing,
  commentsFetching: state.openItems.commentsFetching,
  commentsSuccess: state.openItems.commentsSuccess,
  openItemsCommentsList: state.openItems.openItemsCommentsList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
  dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  // dispatchGetClientsActiveJobAction: (data: GetJobTrackerListingPayload) =>
  //     dispatch(getAllJobsTrackerListAction(data)),
  dispatchResetJobTrackerListing: () => dispatch(resetJobTrackerListing()),
  dispatchGetAdminOpenItemsSingle: (data: any) => dispatch(getAdminOpenItemsSingleAction(data)),
  dispatchUpdateStatusAdminOpenItemsAction: (data: any) => dispatch(updateStatusAdminOpenItemsAction(data)),
  dispatchAddOpenItemCommentsAction: (data: AddOpenItemCommentPayload) =>
    dispatch(addOpenItemCommentsAction(data)),
  dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) =>
    dispatch(getAllOpenItemCommentsAction(data)),
  //   dispatchResetOpenItemCommentsListAction: () => dispatch(resetOpenItemsCommentList())
})

export default connect(mapStateToProps, mapDispatchToProps)(AdminOpenItemSummary);